<template>
    <b-form-group :label="label" label-for="situation">
        <Select
            id="situation"
            :state="state"
            :selected="value"
            aria-describedby="situationsTypeFeedback"
            :options="situationOptions"
            @changeValue="$emit('update:value', $event)"
            :disabled="disabled"
        />
        <b-form-invalid-feedback id="situationsTypeFeedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import defaultSituation from '@/data/situation'
import { Select } from '@/views/components/selects'

export default {
    name: 'Situation',
    components: {
        Select,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            situationOptions: defaultSituation,
        }
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/CustomMultiselect.scss';

.c-th:hover {
    cursor: pointer;
}
</style>
